import React from 'react';
import { Link } from 'react-scroll';
const OnePageMenu = () => {
    return(
        <nav id="topheader" className="d-none d-lg-block navbar navbar-expand-lg justify-content-start py-0 pl-60 pl-lg-0">
            <ul className="navbar-nav list-style-none">
                <li className="nav-item"><Link className='nav-link' to='home' spy={true} activeClass='nav-bar-link-active' smooth={true}  >Home</Link></li>
                <li className="nav-item"><Link className='nav-link' to='about' spy={true}  smooth={true}  >About</Link></li>
                <li className="nav-item"><Link className='nav-link' to='services' spy={true}  smooth={true}  >Services</Link></li>
                <li className="nav-item"><Link className='nav-link' to='projects' spy={true}  smooth={true}  >Project</Link></li>
                <li className="nav-item"><Link className='nav-link' to='news' spy={true}  smooth={true}  >News</Link></li>
                <li className="nav-item"><Link className='nav-link' to='contact' spy={true}  smooth={true}  >Contact</Link></li>
            </ul>
        </nav>
    )
}
export default OnePageMenu